export default __webpack_public_path__ + "static/media/core.d5b0ff2f.jpg";